import en from '@emoji-mart/data/i18n/en.json';
import nl from '@emoji-mart/data/i18n/nl.json';

export default {
  en,
  nl,
};
